import {
  CFormCheck,
  CSpinner,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useQueryClient, useMutation } from "react-query";
import { useToast } from "../../../hooks/useToast";
import { useCookie } from "../../../hooks/useCookie";
import apiService from "../../../service/apiService";
import { DELETE_ACTIONS } from "../../../config/constants";
import { general } from "../../../locales/general";
import { colors } from "../../../config/theme";
import EditIcon from "../../../components/icons/EditIcon";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import PromptModal from "../../../components/modals/PromptModal";
import { Link } from "react-router-dom";

function TableBodyRowContent({
  placeTranslation,
  deletedList,
}: {
  placeTranslation: PlaceTranslation;
  deletedList: React.Dispatch<BulkDeleteActions>;
}) {
  const [isChecked, setIsChecked] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { toastSuccess, toastError } = useToast();
  const { token } = useCookie("vToken");
  const queryClient = useQueryClient();

  const deletePlaceTranslation = useMutation((id: string) => {
    return apiService.MakeDeleteRequest(`place-translations/${id}`, token);
  });

  useEffect(() => {
    if (isChecked) {
      deletedList({ type: DELETE_ACTIONS.ADD, id: placeTranslation.id });
    } else {
      deletedList({ type: DELETE_ACTIONS.REMOVE, id: placeTranslation.id });
    }
  }, [deletedList, isChecked, placeTranslation.id]);

  const removePlaceTranslation = () => {
    deletePlaceTranslation.mutate(placeTranslation.id, {
      onError(error) {
        console.log(error);
        toastError(general.fr.message.operationFailed);
      },
      onSuccess() {
        toastSuccess(general.fr.message.partnerDeleted);
        queryClient.invalidateQueries("getAllTranslations");
      },
    });
  };

  return (
    <CTableRow
      style={{
        borderLeft: isChecked ? `3px solid ${colors.primary}` : "",
        width: "100%",
        position: "relative",
      }}
    >
      <CTableDataCell className=" text-capitalize text-sm">
        <div className="d-flex align-items-center gap-3">
          <CFormCheck
            id="flexCheckDefault"
            label=""
            defaultChecked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            color={colors.yellow}
          />

          <img
            src={
              placeTranslation.place?.logoImage || placeTranslation.place?.image
            }
            alt=""
            width={30}
            height={30}
            style={{ borderRadius: "100%" }}
          />

          <div>
            <Link
              to={`/places/${placeTranslation.place?.id}`}
              className="fw-bold m-0 text-capitalize text-sm"
            >
              {placeTranslation.place?.name}
            </Link>
            <p className="m-0 text-sm">{placeTranslation.place?.city?.label}</p>
          </div>
        </div>
      </CTableDataCell>
      <CTableDataCell className="text-capitalize text-sm">
        <span className="ms-3">{placeTranslation?.name}</span>
      </CTableDataCell>
      <CTableDataCell className="text-capitalize text-sm">
        <span className="ms-3">{placeTranslation?.lang}</span>
      </CTableDataCell>

      <CTableDataCell>
        <Link to={`/place-translations/update/${placeTranslation.id}`}>
          <EditIcon width="18" height="18" fill={colors.secondary} />
        </Link>{" "}
        <button
          className="outline-none border-0 bg-transparent"
          onClick={() => setShowModal(true)}
        >
          {deletePlaceTranslation.isLoading ? (
            <CSpinner size="sm" />
          ) : (
            <DeleteIcon
              width="20"
              height="20"
              fill={colors.primary}
              className="ms-2"
            />
          )}
        </button>
      </CTableDataCell>
      <PromptModal
        open={showModal}
        onAccept={removePlaceTranslation}
        onClose={() => setShowModal(false)}
      />
      {/* <PlaceTranslationModal
                onClose={() => setShowEditModal(false)}
                open={showEditModal}
                id={placeTranslation?.id}
                name={placeTranslation?.name}
                link={placeTranslation?.link}
                logo={placeTranslation?.logoImage}
            /> */}
    </CTableRow>
  );
}

interface TableProps {
  placeTranslations: PlaceTranslation[];
  placeTranslationsToBeDeleted: React.Dispatch<BulkDeleteActions>;
}

export default function PlaceTranslationsTable({
  placeTranslations,
  placeTranslationsToBeDeleted,
}: TableProps) {
  return (
    <div className="mt-3">
      <CTable>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell scope="col">Établissement</CTableHeaderCell>
            <CTableHeaderCell scope="col">Traduction</CTableHeaderCell>
            <CTableHeaderCell scope="col">Langue</CTableHeaderCell>
            <CTableHeaderCell scope="col"></CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {placeTranslations?.map((placeTranslation) => (
            <TableBodyRowContent
              placeTranslation={placeTranslation}
              key={placeTranslation?.id}
              deletedList={placeTranslationsToBeDeleted}
            />
          ))}{" "}
        </CTableBody>
      </CTable>
    </div>
  );
}
